module.exports = __webpack_public_path__ + "img/wiki.fe2e1b4b.svg";